import { render, staticRenderFns } from "./SubRslEvManagementUserVisionReview.vue?vue&type=template&id=6efa55da&scoped=true&"
import script from "./SubRslEvManagementUserVisionReview.vue?vue&type=script&lang=js&"
export * from "./SubRslEvManagementUserVisionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa55da",
  null
  
)

export default component.exports